import { RoleProtected } from '../Components/RoleProtected';
import HomePageView from '../Components/HomePageComp/Views/HomePageView';

export default function HomePage() {
  return (
    <RoleProtected allowedRoles={["user", "Admin"]}>
      <HomePageView />
    </RoleProtected>
  );
}